export default __webpack_public_path__ + "static/media/succulent.f4329849.jpg";